import { Routes } from '@angular/router';
import { LoginGuard } from './auth/login.guard';
import { AuthenticationGuard } from './auth/authentication.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
        canMatch: [LoginGuard]
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
        canMatch: [AuthenticationGuard]
    },
    {
        path: 'privacy-center',
        loadChildren: () => import('./pages/privacy-center/privacy-center-orders.module').then(m => m.PrivacyCenterOrdersModule),
    },
    {
        path: 'maturity-form-fill',
        loadChildren: () => import('./pages/maturity-form-fill/maturity-form-fill.module').then(m => m.MaturityFormFillModule),
    },
    {
        path: 'formularios-empresariais',
        loadChildren: () => import('./pages/formularios-empresariais/formularios-empresariais.module').then(m => m.FormulariosEmpresariaisModule),
    }
];
